
import { Component, Ref, Vue } from 'vue-property-decorator'
import AcademyBranchList from '@/components/templates/manage/AcademyBranchList.vue'
import { BranchList } from '@/models/manage/BranchList'
import { BranchesApi } from '@/api/methods/manage/BranchesApi'

/**
 * 教室一覧画面
 */
@Component({
  components: {
    AcademyBranchList,
  },
})
export default class AcademyBranches extends Vue {
  /** 教室一覧 */
  @Ref()
  academyBranchList!: AcademyBranchList

  /** 教室一覧 */
  private branchList: BranchList[] = []

  /** 1ページの最大件数 */
  private readonly MAX_PER_PAGE = 7

  /** ページ数 */
  private pageLength = 0

  /** 現在のページ */
  private currentPage = 1

  /**
   * 検索欄に入力された文字列
   *
   * @returns 入力された文字列(空文字の場合nullを返す)
   */
  private get textInputedSearch(): string | null {
    return this.academyBranchList.textInputedSearch || null
  }

  /**
   * 初期処理
   */
  private async mounted(): Promise<void> {
    this.$loading.start()
    // 教室一覧取得
    this.getBranchList()
    this.$loading.complete()
  }

  /**
   * 教室一覧取得
   */
  private async getBranchList(): Promise<void> {
    // 教室一覧取得
    const branchList = await BranchesApi.searchBranches(this.textInputedSearch, this.currentPage, this.MAX_PER_PAGE)

    // 取得対象の合計数から、全体のページ数を算出
    const length = branchList.totalCount
    const divideNumber = Math.floor(length / this.MAX_PER_PAGE)
    this.pageLength = length % this.MAX_PER_PAGE ? divideNumber + 1 : divideNumber

    // 教室一覧を設定
    this.branchList = branchList.branches
  }

  /**
   * 検索ボタン押下時の処理
   */
  private searchStudent(): void {
    // 現在のページ数を初期値に戻す
    this.currentPage = 1
    // 教室一覧取得
    this.getBranchList()
  }

  /**
   * ページリンク押下時の処理
   *
   * @param value ページ番号/戻る/進む
   */
  private changePage(value: number): void {
    this.$loading.start()
    // 現在のページ番号を更新
    this.currentPage = value
    // 教室一覧取得
    this.getBranchList()
    this.$loading.complete()
  }
}
